module.exports = __webpack_public_path__ + "static/media/RR-waving-rc.cea9d120.jpg";